module.exports = __webpack_public_path__ + "static/img/gold_ring.46296c4.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/prizes/gold_ring.png
// module id = qZqA
// module chunks = 1